import React from 'react';
import Modal from './Modal';
import { Button, DialogContent, DialogActions, Box, Typography } from '@mui/material';

interface CraftSelectionModalProps {
  onClose: () => void;
  onSelect: (craft: 'knitting' | 'crochet' | 'cross_stitch') => void;
}

export default function CraftSelectionModal({ onClose, onSelect }: CraftSelectionModalProps) {
  const crafts = [
    { value: 'knitting', label: 'Knitting' },
    { value: 'crochet', label: 'Crochet' },
    { value: 'cross_stitch', label: 'Cross Stitch' }
  ] as const;

  return (
    <Modal title="Choose Your Craft" onClose={onClose}>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
          {crafts.map((craft) => (
            <Button
              key={craft.value}
              variant="outlined"
              fullWidth
              size="large"
              onClick={() => onSelect(craft.value)}
              sx={{ py: 2 }}
            >
              <Typography variant="h6">{craft.label}</Typography>
            </Button>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Modal>
  );
}
